import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { id } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Observer, Subject } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

export interface node{
  name:string;
  id:string;
}

export interface CategoryNode{
    node:node,
    data:Object
}  


@Component({
    selector: 'meli-category-finder',
    templateUrl: './meli-category-finder.component.html',
    styleUrls: ['./meli-category-finder.component.scss'],
    standalone: false
})
export class MeliCategoryFinderComponent implements OnInit {

  currentLevel = 0;
  rootLevelNodes:node[] = [];
  codecompany: any;
  
  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data,public ThemeService:ThemeService, public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }

  header:string[] =['Principal'];
  deep:string = "";
  stepSubjet:Subject<node> = new Subject<node>();
  currentStep:Subject<CategoryNode> = new Subject<CategoryNode>();
  steps:node[] = [];
  stepsData:CategoryNode[] = [];
  @ViewChild('stepper') stepper: MatStepper;
  currentData:CategoryNode;
  isNewMode:boolean = true;
  
  ngOnInit(): void {
    
    this.codecompany = (this.data as UntypedFormGroup).get("CODECOMPANY").value;

    if ( this.codecompany == null){
        this.codecompany = this.uid.user.codecompany;
    }
    
    this.isNewMode = this.data == null ? true : this.data;

    this.stepSubjet.subscribe(item=>{
      
        this.getCategoria(item);
        setTimeout(()=>{
          this.stepper.next();
          this.cd.markForCheck();
        })
        
    })

    let ob = {
      codeCompany : this.codecompany,
      method: "GET",
      serviceName: "AllCategories",
    }

    
    this.spinner.show("melisearchcategory");
    this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
        this.rootLevelNodes = data['resultado'];
        this.cd.markForCheck();
        this.spinner.hide("melisearchcategory");
    },(error)=>{
      this.spinner.hide("melisearchcategory")
    });

  }

  selectItem(item:node){
    this.steps.push(item);            
    this.stepSubjet.next(item);
    this.header.push(item.name);
    
  }

  headerClicked(index:number){
    this.steps.splice(index);
    this.header.splice(index+1);
    if ( index - 1 >=0 ){
      this.getCategoria(this.steps[index-1]);
    }
    
  }

  getCategoria(item:node){

    let ob = {
      codeCompany : this.codecompany,
      method: "GET",
      serviceName: "ByCategorieId",
    }

    ob['params']=[{
        key:"@CATEGORYID",
        value:item.id
    }];

    let selected = this.stepsData.find(s=>s.node.id == item.id);
    
    this.spinner.show("melisearchcategory");
    if ( selected == null ){
      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(data=>{
        
        let childItem = data['resultado'];

        this.stepsData.push({node:item,data:childItem})
        this.currentData =  {node:item,data:childItem};
        this.currentStep.next(this.currentData);
        this.spinner.hide("melisearchcategory");
      });
    }else{
          this.spinner.show("melisearchcategory");
          setTimeout(calback=>{
            this.currentData = selected;
            this.currentStep.next(this.currentData);
            this.cd.markForCheck();
            this.spinner.hide("melisearchcategory");
          }) 
    }

  }

  getCurrentStep(item:node){
      return this.stepsData.find(x=>x.node.id == item.id);
  }

  selectData(data){
    if ( this.isNewMode ){
      this.dialogRef.close(data.id);
    }else{
      this.dialogRef.close(data);
    }
    
  }
}
